export const APPLY_FILTER_CRITERIAS = "filter/APPLY_FILTER_CRITERIAS";
export const CLEAR_FILTER_CRITERIAS = "filter/CLEAR_FILTER_CRITERIAS";
export const RESET_FILTER_CRITERIAS = "filter/RESET_FILTER_CRITERIAS";
